module.exports = __webpack_public_path__ + "img/0-96.4688489e.jpg";